<template>
  <div class="curriculum-page">
    <div class="cross">
      <div class="fixed-table">
        <CurriculumTable :list="list"></CurriculumTable>
      </div>
      <div class="body-table">
        <CurriculumTable :list="list" @openSchedule="openSchedule"></CurriculumTable>
      </div>
    </div>
    <van-dialog :class="screenType == 0 ? 'curriculum-heng-dialog':'curriculum-shu-dialog'" v-model="showDialog" :show-confirm-button="false" :show-cancel-button="false" :close-on-click-overlay="true" get-container="#app">
      <div class="curriculum-dialog-closebutton" v-if="screenType == 0" @click="showDialog=false">
        <span class="iconfont icon-icon_wrong"></span>
      </div>
      <one-week-schedule v-if="showDialog" ref="oneWeekSchedule" :openClass="openClass"></one-week-schedule>
    </van-dialog>
  </div>
</template>

<script>
import CurriculumTable from "./curriculumTable.vue";
import oneWeekSchedule from "./oneWeekSchedule.vue";
export default {
  name: "curriculum",
  components: {
    CurriculumTable,
    oneWeekSchedule,
  },
  data() {
    return {
      showDialog: false,
      list: [],
      screenType: 0, //屏幕类型：0为横向，1为纵向
      openClass: {},
    };
  },
  created() {
    this.screenType = this.$route.meta.screenType;
    this.getData();
  },
  methods: {
    getData() {
      var loading = dsf.layer.loading();
      this.$http
        .get("teas/screen/classCurriculum")
        .done((res) => {
          if (res.success && res.state == 20000) {
            console.log(res);
            this.list = res.data;
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    clickItem(item) {
      this.showDialog = true;
    },
    openSchedule(item){
      this.openClass = item;
      this.showDialog = true;
    },
  },
};
</script>

<style>
</style>